import {get} from "$lib/api";

export const getLanguages = async () => {
    return await get('/i18n/languages')
}